module.exports = __webpack_public_path__ + "static/media/22.2e8a0016.jpg";